import { render, staticRenderFns } from "./QaReadDialog.vue?vue&type=template&id=04b511ce&"
import script from "./QaReadDialog.vue?vue&type=script&lang=js&"
export * from "./QaReadDialog.vue?vue&type=script&lang=js&"
import style0 from "./QaReadDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports